module.exports = __webpack_public_path__ + "img/step-forward.74bf317b.svg";